// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2069":"6cd95769","9390":"88205202"}[chunkId] + ".chunk.css";
};